import { observer } from 'mobx-react-lite';
import StepBar from './components/steps/StepBar';
import { ReactNode } from 'react';
import { STEP_REGISTRATION_CONFIG } from '@shared/components/constants/common.constants';

interface props {
    currentStep: number,
    children: ReactNode
}
export default observer(function RegistrationAccountLayout(props: props) {
    // hook
    const { currentStep, children } = props;

    // lifecycle

    // function
    return (
        <div className='container mx-auto px-4 max-w-[700px] py-10 flex flex-col gap-4'>
            <div className='flex md:hidden w-full flex-col md:gap-8 gap-6 items-center'>
                <h1 className='text-center font-bold page-title-hero'>新規アカウント登録</h1>
                <StepBar currentStep={currentStep} stepConfig={STEP_REGISTRATION_CONFIG} />
            </div>
            <div className='flex flex-col md:gap-8 gap-6 items-center bg-[#F1F1F1] w-full rounded-[10px] px-4 py-6 md:p-10'>
                <div className='hidden md:flex w-full flex-col md:gap-8 gap-6 items-center'>
                    <h1 className='text-center font-bold page-title-hero'>新規アカウント登録</h1>
                    <StepBar currentStep={currentStep} stepConfig={STEP_REGISTRATION_CONFIG} />
                </div>
                <div className='w-full'>
                    {children}
                </div>
            </div>
        </div>
    );
});
